<template>
      <v-dialog v-model="open" :max-width="tamModal" :scrollable="$root.isTouch == false" :fullscreen="$root.isTouch"
            persistent>
            <v-card elevation="11">
                  <v-card-title class="bg-title-card">
                        <span class="white--text headline" v-html="obModal.titulo"></span>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" v-if="$root.isTouch" rounded outlined @click="close(false)">
                              <v-icon color="white">close</v-icon>
                        </v-btn>
                  </v-card-title>
                  <v-card-text>

                        <v-container fluid>
                              
                              <v-row dense>
                                    <v-col cols="12" sm="6"></v-col>
                                    <v-col cols="12" sm="6">
                                          <v-text-field label="Buscar" color="textbox" v-model="obModal.search" clearable
                                                dense prepend-inner-icon="search" />
                                    </v-col>
                              </v-row>

                              <v-row dense>
                                    <v-col cols="12" sm="12">
                                          <v-data-table :search="obModal.search"
                                                :headers="listGeneral.cabeceraModal" :items="listGeneral.detalleModal"
                                                class="elevation-3">

                                                <template v-slot:body.append>
                                                      <tr>
                                                            <td colspan="9"></td>
                                                            <td>
                                                                  <span class="font-weight-black"
                                                                        v-html="`$${Number.parseFloat(totalPrimaNeta).toFixed(4) }`"></span>
                                                            </td>
                                                            <td>
                                                                  <span class="font-weight-black"
                                                                        v-html="`$${Number.parseFloat(totalImpuesto).toFixed(4) }`"></span>
                                                            </td>
                                                            <td>
                                                                  <span class="font-weight-black"
                                                                        v-html="`$${Number.parseFloat(totalPrimaBruta).toFixed(4) }`"></span>
                                                            </td>
                                                      </tr>
                                                </template>

                                                <template v-slot:no-results>
                                                      Tu búsqueda de "<span v-html="obModal.search"></span>" no arrojó
                                                      resultados.
                                                </template>
                                          </v-data-table>
                                    </v-col>
                              </v-row>

                              <v-row dense>
                                    <v-col cols="12" sm="12" class="text-right">
                                          <v-btn outlined dense rounded class="mr-1" @click="close(false)">Cancelar
                                          </v-btn>
                                    </v-col>
                              </v-row>
                        </v-container>

                  </v-card-text>
            </v-card>
      </v-dialog>
</template>

<script>
      export default {
            name: 'ModalInformeLiquidacionComponent',
            inject: ['close'],
            props: {
                  open: {
                        type: Boolean,
                        default: false
                  },
                  obModal: {
                        type: Object,
                        default: {}
                  },
                  listGeneral: {
                        type: Object,
                        default: {}
                  },
                  parametros: {
                        type: Object,
                        default: {}
                  }
            },
            computed: {
                  totalPrimaNeta() {
                        var l = _.cloneDeep(_.get(this.listGeneral,'detalleModal',[]));
                        return _.sumBy(l, (v) => {
                              return _.toNumber(v.primaBruta);
                        });
                  },
                  totalImpuesto() {
                        var l = _.cloneDeep(_.get(this.listGeneral,'detalleModal',[]));
                        return _.sumBy(l, (v) => {
                              return _.toNumber(v.impuestos);
                        });
                  },
                  totalPrimaBruta() {
                        var l = _.cloneDeep(_.get(this.listGeneral,'detalleModal',[]));
                        return _.sumBy(l, (v) => {
                              return _.toNumber(v.primaNeta);
                        });
                  },
            },
      }
</script>